import React from 'react';
import { FieldSelector } from 'src/components/Flowsteps/PushData/Mapping/common';
import { observer } from 'mobx-react';
import { Checkbox } from '@fluentui/react';
import { useStyles } from './ColumnFieldMappingEditor.styles';
import { FormControl } from '@v2/components/controls/FormControl/FormControl';
import { DataField } from 'shared/providers/types';

export type ColumnFieldMappingEditorState = {
  columnName: string;
  fieldName: string;
  checked: boolean;
};

interface ColumnFieldMappingEditorProps {
  objectFields: DataField[];
  state: ColumnFieldMappingEditorState;
  errorMessage?: string;
}

export const ColumnFieldMappingEditor: React.FC<ColumnFieldMappingEditorProps> = observer((props) => {
  const { state, objectFields, errorMessage } = props;
  const styles = useStyles();

  return (
    <FormControl label={`Column '${state.columnName}'`}>
      <div className={styles.controls}>
        <Checkbox onChange={() => state.checked = !state.checked} checked={state.checked} />
        <FieldSelector
          disabled={false}
          options={objectFields.map((field) => ({ key: field.name, text: field.label }))}
          selectedKey={state.fieldName}
          onChange={(item: any) => state.fieldName = item.key}
          placeholder={''}
          invalid={!!errorMessage}
        />
        <div></div>
        <div className={styles.errorMessage}>
          {!!errorMessage && errorMessage}
        </div>
      </div>
    </FormControl>
  );
});
